import { render, staticRenderFns } from "./WhitelabelDemo.vue?vue&type=template&id=f7168a32&scoped=true"
import script from "./WhitelabelDemo.vue?vue&type=script&lang=ts"
export * from "./WhitelabelDemo.vue?vue&type=script&lang=ts"
import style0 from "./WhitelabelDemo.vue?vue&type=style&index=0&id=f7168a32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7168a32",
  null
  
)

export default component.exports